import {
  ActionIcon,
  Button,
  Divider,
  Flex,
  Group,
  Paper,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import CampaignFilter from "./CampaignFilter";
import {
  IconPlus,
  IconSpeakerphone,
  IconSwitchVertical,
} from "@tabler/icons-react";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import DownloadAllCampaigns from "./components/DownloadAllCampaigns";
import ZapierSettings from "../../leadsTracking/titleSection/zapier/ZapierSettings";
import Signage from "../../../../layouts/Header/Signage";
import { useEffect, useState } from "react";
import { useUIStore } from "../../../../stores/UIStore";
import FolderAdder from "../../lists/ListingWithContent/contacts/FolderAdder";
import { useListStore } from "../../../../stores/ListStore";
import WorkflowTemplates from "../../workflows/templates/WorkflowTemplates";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useReportingStore } from "../../../../stores/ReportingStore";
import WebhooksSettings from "../../workflows/webhooks/WebhooksSettings";
import { getPermission } from "../../../../functions/utilFunctions";
import CampaignFilterType from "./CampaignFilterType";
import WorkflowFilterType from "./workflows/WorkflowFilterType";
import { getBlacklists } from "../../../../api/BlacklistAPI";

const Campaigns = () => {
  const lang = useLanguage((s) => s.language);
  const location = useLocation();
  const isDraft = location.pathname.includes("workflows");
  const isFolder = location.pathname.includes("folder");
  const global_stats = useReportingStore((s) => s.globalStats);
  const [initialized, setInitialized] = useState(false);

  const { filter } = useParams();

  const navigate = useNavigate();
  const handleWorkflowModelUse = (item, handleClose) => {
    handleClose();

    navigate(`/campaign/create?libraryId=${item.id}`);
  };

  useEffect(() => {
    if (
      filter === "running" &&
      global_stats?.programmation_running === 0 &&
      !initialized
    ) {
      navigate("/statistics/campaigns/workflows");
      setInitialized(true);
    }
  }, [initialized, filter, global_stats?.programmation_running, navigate]);

  const { folderId } = useParams();

  useEffect(() => {
    let locked = useUIStore.getState().pinnedNavbar;
    if (!locked) {
      useUIStore.getState().setNavbarClosed(true);
      useUIStore.getState().setCampaignOpened(false);
    }
    getBlacklists();
  }, []);

  return (
    <Stack gap={0} px={64} className="campaigns-page">
      <Paper mt={32} mb={24} component={Group} p={"md"} gap={"md"}>
        <ThemeIcon size={"xl"} radius={"md"} variant="filled" color="primary">
          <IconSpeakerphone size={32} />
        </ThemeIcon>

        <Text fw={700} fz={24}>
          {isFolder && !folderId
            ? lang.prospects.my_folders
            : lang.campaigns.main_title}
        </Text>
        {isDraft ? (
          isFolder ? (
            <Tooltip
              label={`${lang.prospects.swap_to} ${lang.campaigns.main_title}`}
            >
              <ActionIcon
                variant="light"
                size={"lg"}
                component={Link}
                to={"/statistics/campaigns/workflows"}
              >
                <IconSwitchVertical />
              </ActionIcon>
            </Tooltip>
          ) : (
            <Tooltip
              label={`${lang.prospects.swap_to} ${lang.prospects.my_folders}`}
            >
              <ActionIcon
                variant="light"
                size={"lg"}
                component={Link}
                to={"/statistics/campaigns/workflows/folder"}
              >
                <IconSwitchVertical />
              </ActionIcon>
            </Tooltip>
          )
        ) : (
          <DownloadAllCampaigns />
        )}
        {!isDraft && (
          <>
            <ZapierSettings type="statistics" />
          </>
        )}

        <Divider orientation="vertical" ml={12} />

        <Group gap={"lg"} ml={"auto"}>
          {!isDraft && <Signage />}
          {isDraft && <WorkflowTemplates onCreated={handleWorkflowModelUse} />}

          {getPermission("displayWebhookStatistics") && <WebhooksSettings />}

          {isFolder && !folderId ? (
            <FolderAdder
              type={"Workflow"}
              onFinish={() => useListStore.getState().setListingLoad(true)}
              isButton
            />
          ) : (
            <Button
              leftSection={<IconPlus size={18} />}
              radius={"md"}
              color="primary"
              component={Link}
              to={"/campaign/create"}
              size="md"
              ml={"auto"}
            >
              {lang.campaigns.create_campaign}
            </Button>
          )}
        </Group>
      </Paper>

      <Flex h={"calc(100vh - 175px)"}>
        <Stack flex={"1 1 auto"} w={0} miw={"100%"} gap={0}>
          <Group mb={-48}>
            <CampaignFilter />

            {!isDraft && !isFolder && <CampaignFilterType />}
            {isDraft && !isFolder && <WorkflowFilterType />}
          </Group>

          <Outlet />
        </Stack>
      </Flex>
    </Stack>
  );
};

export default Campaigns;
